<template>
  <div class="p-0 mt-3">
 
    <VueTailwindDatepicker 
     :autoApply="true"
     :shortcuts="false" 
     :useRange="useRange" 
     :i18n="lang" :formatter="formatter"
     :startFrom="startFrom"  
      v-model="dateValue" 
      @update:modelValue="handleApply"  />


  </div>
</template>


<script>
import { ref } from 'vue'
import VueTailwindDatepicker from 'vue-tailwind-datepicker'
import i18n from "@/i18n";

export default {
  components: {
    VueTailwindDatepicker
  },
  props: ['fechasSeleccionadas'],
  emits: ['getFecCalendarExcel'],
  mounted() {
   this.startFrom = this.fechasSeleccionadas[0]
      this.dateValue = this.fechasSeleccionadas
     this.lang= i18n.global.locale.value ;
  },
  data() {
    return {
      showRegularDate: true,
      checkin: '',
      placeholder:'Seleccione dias',
      startFrom: '',
      dateValue: '',
      formatter: ref({
        date: 'DD MM YYYY',
        month: 'MMM',

      }),
      lang:''

    }
  },
 
  watch: {
    fechasSeleccionadas(value) {
      
      this.startFrom = value[0]
      this.dateValue = value
    },
    
  },
  methods: {
    closeDatePickerPopup() {
   
    
      // here you have access to this.regularDate
      // and you could do whatever you want with this.regularDate
    },
      handleApply(){
     
      ////console.log(this.dateValue, "<--");
      this.$emit("getFecCalendar", this.dateValue)
    },
    getFecCalendar() {

      ////console.log(this.dateValue, "<--");
      this.$emit("getFecCalendar", this.dateValue)


    },
   
  },
}
</script>